class SearchDataManager {
    _networkClient;
    dfpProtectedAuth;
    constructor(_networkClient, dfpProtectedAuth){
        this._networkClient = _networkClient;
        this.dfpProtectedAuth = dfpProtectedAuth;
    }
    searchUser(email) {
        return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha().then(({ dfp_telemetry_id, captcha_token })=>{
            return this._networkClient.fetchSDK({
                url: `/users/search`,
                method: 'POST',
                body: {
                    email,
                    dfp_telemetry_id,
                    captcha_token
                }
            });
        });
    }
    searchMember(email, organization_id) {
        return this._networkClient.fetchSDK({
            url: `/b2b/organizations/members/search`,
            method: 'POST',
            body: {
                email_address: email,
                organization_id
            }
        });
    }
}

export { SearchDataManager };
//# sourceMappingURL=SearchManager.mjs.map
